<template>
  <div class="card card-map">
    <div>
      <div class="content">
        <div class="row">
          <div class="wrap">
            <span class="flex-item datetime">
              <fg-input type="number"
              :min=1
              :max=60
              v-model="interval"
              :placeholder="translate('gps_track.interval_placeholder')"
              :label="translate('gps_track.interval_lable')"
              />
            </span>

            <span class="flex-item tracking-date-range" >
              <fg-input type='datepicker'
              :label="translate('gps_track.date_range')"
              :placeholder="translate('gps_track.period_placeholder')"
              v-model="time1"
              :range="true"
              @clear="handleRangeClose"
              :disabled-date="disabledDate"
              />
            </span>

            <span class="flex-item time-start-end" >
              <fg-input type='time'
              :label="translate('gps_track.start_time')"
              :placeholder="translate('gps_track.start_time_placeholder')"
              :range="false"
              v-model="time2"
              @clear="closeStartTime"
              />
            </span>

            <span class="flex-item time-start-end time-end " >
              <fg-input type='time'
              :label="translate('gps_track.end_time')"
              :placeholder="translate('gps_track.end_time_placeholder')"
              :range="false"
              v-model="time3"
              @clear="closeEndTime"
              />
            </span>
          </div>
          <span
            type="submit"
            class="mdi btn btn-info btn-apply"
            @click.prevent="showTrack"
          >
            {{ translate('gps_track.show_btn_track')}}
          </span>
        </div>
      </div>
    </div>

    <gmap-map
      :zoom="9"
      :center="center"
      style="width: 100%; height: 500px"
      @click="click_find_distance"
      @rightclick="rightclick_find_distance"
    >

      <gmap-marker
        v-for="(marker, index) in distance_markers"
        :key="'distance'+index"
        :position="marker"
        :icon="{ url: require('assets/icons/sistematics_dist.png')}"
        :draggable="false"
      />

      <gmap-polyline
        :path="distance_markers"
        :coords.sync="distance_markers"
        :options="{
          strokeColor:'#7f058f',
          strokeOpacity: 1.0,
          strokeWeight: 3,
          icons: [{
            icon: {
              path: 0,
              scale: 3
            },
            offset: '1',
            repeat: '100px'
          }]
        }"
      />

      <gmap-polyline
        :path="all_coords"
        :coords.sync="all_coords"
        :options="{
          strokeColor:'#000000',
          strokeOpacity: 1.0,
          strokeWeight: 2,
          icons: [{
            icon: {
              path: 1,
              scale: 2
            },
            offset: '0',
            repeat: '100px'
          }]
        }"
      />

      <gmap-marker
        v-for="(item,index) in coords"
        :key="index"
        :position="item"
        :icon="{ path: 0, scale: 3, strokeColor:'', fillColor: '', fillOpacity: 0}"
        :clickable="true"
        :draggable="false"
        @click="openInfoWindow(item)"
      />

      <gmap-marker
        :position="last_coord"
        :icon="this.last_coord_icon"
        :clickable="true"
        :draggable="false"
        @click="openInfoWindow(last_coord)"
      />

      <gmap-info-window
        :options="{maxWidth: 300, pixelOffset: {width: 0, height: -35}, content: this.info, strokeColor:'#FF0000'}"
        :position="infoWinPos"
        :opened="infoBoxOpen"
        @closeclick="infoBoxOpen=false"
        >
      </gmap-info-window>

      <gmap-info-window
        :options="{
          maxWidth: 300,
          pixelOffset: {
            width: 0,
            height: -10
          },
          content: distanceInfo,
          strokeColor:'#FF0000'
        }"
        :position="distancePos"
        :opened="distanceOpen"
        @closeclick="clear_find_distance()"
        >
      </gmap-info-window>
    </gmap-map>
  </div>
</template>

<script>


export default {
  name: 'Maps',

  props: [ 'dev_id'],
  data () {
    let defaultDate = new Date()
    let todayDefaultDate = new Date(defaultDate.getFullYear(), defaultDate.getMonth(), defaultDate.getDate())

    return {
      info: '',
      infoBoxOpen: false,
      infoWinPos: {lat: 0, lng:0},
      all_coords:[],
      interval: null,
      statusText: '',
      infoContent:'',
      showdatetrack: false,
      date:[],
      time1:[""+(+(todayDefaultDate/1000)), ""+(+(todayDefaultDate/1000) + 86399)],
      time2:[],
      time3:[],
      center:{lat: 56.011755, lng:92.875629},
      show_last_position: true,
      show_last_info: true,

      distanceInfo: '',
      distanceOpen: false,
      distancePos: {lat: 0, lng:0},
      start_find: false,
      distance_markers: []
    }
  },
  mounted(){
    this.showTrack()
  },
  watch:{
    cur_id () {
      this.showTrack()
    },
  },
  computed:{
    final_distance() {
      let lat1,lon1,lat2,lon2
      for (let marker of this.distance_markers) {
        if (marker.type === 'first') {
          lat1 = marker.lat
          lon1 = marker.lng
        }else if (marker.type === 'second') {
          lat2 = marker.lat
          lon2 = marker.lng
        }
      }

      let R = 6371000; // Radius of the earth in m
      let dLat = this.deg2rad(lat2-lat1);  // deg2rad below
      let dLon = this.deg2rad(lon2-lon1);
      let a =
        Math.sin(dLat/2) * Math.sin(dLat/2) +
        Math.cos(this.deg2rad(lat1)) * Math.cos(this.deg2rad(lat2)) *
        Math.sin(dLon/2) * Math.sin(dLon/2)
        ;
      let c = 2 * Math.atan2(Math.sqrt(a), Math.sqrt(1-a));
      let d = R * c; // Distance in m
      return Math.trunc(d)
    },
    cur_id () { return this.$route.params.device_id },
    last_coord(){
      return this.all_coords[this.all_coords.length - 1]
    },
    last_coord_icon(){
      return (this.all_coords[this.all_coords.length - 1] && (this.all_coords[this.all_coords.length - 1].ts*1000 + 60*60*1000) < new Date().getTime())  ? { url: require('assets/icons/sistematics_offline.png')} : { url: require('assets/icons/sistematics_online.png')}
    },
    coords(){
      let coords = this.all_coords.slice()
      coords.pop()
      return coords
    },
    datetime_picker(){
      return this.$store.getters.getDatetimePicker
    }
  },

  methods: {
    deg2rad(deg) {
      return deg * (Math.PI/180)
    },
    clear_find_distance(){
      this.distanceOpen = false
      this.distance_markers = []
    },
    click_find_distance(event){
      if (event.domEvent.ctrlKey) {
        for (let index_marker in this.distance_markers) {
          if (this.distance_markers[index_marker].type === 'first') {
            this.distance_markers.splice(index_marker, 1);
          }
        }
        let coord = {
          lat: event.latLng.lat(),
          lng: event.latLng.lng(),
          type: 'first'
        }
        this.distance_markers.push(coord)

        this.openInfoWindowDistance(coord)
      }
    },
    rightclick_find_distance(event){
      if (event.domEvent.ctrlKey) {
        for (let index_marker in this.distance_markers) {
          if (this.distance_markers[index_marker].type === 'second') {
            this.distance_markers.splice(index_marker, 1);
          }
        }
        let coord = {
          lat: event.latLng.lat(),
          lng: event.latLng.lng(),
          type: 'second'
        }
        this.distance_markers.push(coord)

        this.openInfoWindowDistance(coord)
      }
    },
    disabledDate(date) {
      let today = new Date();
      return date > new Date(today.getTime()) || date < new Date(today.getTime() - this.datetime_picker * 24 * 3600 * 1000);
    },
     showTrack () {
       if (this.$route.params.device_section === 'tracking') {
         this.infoBoxOpen = false
         this.all_coords = []
         let interimTimeStart = []
         let selectedTimeStart = []
         let interimTimeEnd = []
         let selectedTimeEnd = []

         if (this.time1.length === 0) {
           this.global_notify('info', this.translate('gps_track.select_date_range'))
           return
         }
         if (this.time2.length === 0) {
           selectedTimeStart = 0
         } else {
           interimTimeStart = new Date (this.time2*1000)
           selectedTimeStart = +((interimTimeStart.getHours()*3600) + (interimTimeStart.getMinutes()*60) + interimTimeStart.getSeconds())
         }
         if (this.time3.length === 0) {
           selectedTimeEnd = 0
         } else {
           interimTimeEnd = new Date (this.time3*1000)
           selectedTimeEnd = +((interimTimeEnd.getHours()*3600) + (interimTimeEnd.getMinutes()*60) + interimTimeEnd.getSeconds() - 86399)
         }
         if (this.$route.name === 'device_section'){
           this.$http.v1.getTrackGps(this.dev_id, {
             "period": (( !this.interval ) ? 30 : this.interval),
             "start": +(+this.time1[0] + selectedTimeStart),
             "end": +(+this.time1[1] + selectedTimeEnd),
             "show_last_position": this.show_last_position
           },(response) => {
             this.show_last_position = false
             if(response.data.track.length < 1) {
               this.global_notify('warning', this.translate('no_data'))
             } else {
               this.center = {
                 lat: response.data.track[response.data.track.length - 1].lat,
                 lng: response.data.track[response.data.track.length - 1].long
               }
               this.all_coords = []
               for(let i in response.data.track) {
                 this.all_coords.push({
                   lat: response.data.track[i].lat,
                   lng: response.data.track[i].long,
                   state: response.data.track[i].state,
                   ts: response.data.track[i].ts
                 })
               }
               if (this.show_last_info) {
                 this.openInfoWindow(this.last_coord)
                 this.show_last_info = false
               }
             }
           }
         )
       }
     }
   },
   openInfoWindow (item) {
     this.infoWinPos = item
     this.infoBoxOpen = true
     let status = this.get_date(item.ts) + '<br/>';
     for( let i in item.state) {
       status += item.state[i].slot + ' ' + item.state[i].mno + ' ' + item.state[i].signal + ' ' +  item.state[i].sig_lvl + '<br/>'
     }
     this.info = status
   },

    openInfoWindowDistance (item) {
      if (this.final_distance) {
        this.distancePos = item
        this.distanceOpen = true
        if (this.final_distance < 999) {
          this.distanceInfo = this.final_distance + ' м'
        }else if (this.final_distance > 4999) {
          this.distanceInfo = (this.final_distance/1000) .toFixed(1) + ' км.'
        }else{
          this.distanceInfo = (this.final_distance/1000).toFixed(2) + ' км.'
        }
      }
    },

    handleRangeClose() {
      this.time1 = []
    },

    closeStartTime() {
      this.time2 = []
    },

    closeEndTime() {
      this.time3 = []
    },
  },
}

</script>

<style lang="scss">

 .buttonP {
   position: absolute;
   left: 10px;
   top: 8px;
    }

 .tracking-date-range{
    top: 8px;
    .mx-datepicker-range {
      min-width: 100%;
    }
     .mx-icon-calendar {
      display: none;
    }
  }
  .time-start-end {
    top: 8px;
    .mx-datepicker {
      width: 100%;
    }
    .mx-icon-calendar {
      display: none;
    }
  }
  .distance{
    &_wrap{
      display: flex;
      justify-content: flex-start;
      align-items: flex-end;
      .btn{
        margin-right: 10px;
      }
      .form-group{
        margin: 0;
      }
    }
  }

  .card-map .content .row {
    display: flex;
    justify-content: space-between;
    align-items: flex-end;
    margin: 8px 0;

    .wrap{
      width: 89.5%;
      display: flex;
      justify-content: space-between;
      align-items: center;
      flex-wrap: wrap;
    }
    .btn-apply{
      width: 9.5%;
      padding: 8px 20px;
    }
    .flex-item{
      width: 24%;
      .form-group{
        margin-bottom: 0;
        label{
          font-size: 15px;
          margin-bottom: 5px;
          height: auto;
        }
      }
    }
    &::before{
      content: none;
    }
    &::after{
      content: none;
    }
  }
  @media (max-width:1150px) {
    .card .content .row {
      flex-direction: column;
      align-items: flex-start;
      .wrap{
        width: 100%;
      }
      .flex-item{
        width: 49%;
        .form-group{
          margin-bottom: 15px;
        }
      }
      .btn-apply{
        width: auto;
      }
    }
  }
  @media (max-width:475px) {
    .card .content .row {
      .flex-item{
        width: 100%;
      }
    }
  }
</style>
